/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { StyledEngineProvider } from '@mui/material/styles';

import App from './containers/App';

import {store, history} from './store';

import { translationMessages } from './i18n' ;

import GoogleAnalytics from './utils/GoogleAnalytics';

import { library } from '@fortawesome/fontawesome-svg-core'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab, fal);

const MOUNT_NODE = document.getElementById('root');

GoogleAnalytics.initialize();

const root = ReactDOM.createRoot(MOUNT_NODE);

const render = (messages) => {
  return root.render(
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <Router history={history}>
          <App />
        </Router>
      </StyledEngineProvider>
    </Provider>
  );
};

//Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise(resolve => {
    resolve(import('intl'));
  })
    .then(() =>
      Promise.all([
        import('intl/locale-data/jsonp/en.js'),
        import('intl/locale-data/jsonp/de.js'),
      ]),
    )
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
} else {
  render(translationMessages);
}

